/**
 * @generated SignedSource<<049bd64f419f3cbb79857e3853141020>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InaTransactionsBadge_seller$data = {
  readonly inaTransactions: {
    readonly inaCount: number | null;
    readonly inaPercentage: number | null;
    readonly isPercentage: boolean | null;
  } | null;
  readonly " $fragmentType": "InaTransactionsBadge_seller";
};
export type InaTransactionsBadge_seller$key = {
  readonly " $data"?: InaTransactionsBadge_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"InaTransactionsBadge_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InaTransactionsBadge_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "INATransactionResults",
      "kind": "LinkedField",
      "name": "inaTransactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inaCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inaPercentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPercentage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "4520c4673048686d5a06b6db46c2b087";

export default node;
